<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1150" scrollable>
    <v-card class="dialog_content">
      <v-card-title class="sensor-product-title py-2">
        센서 제품(모델) 정보
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-3">
        <v-layout wrap>
          <v-card class="ma-1 pa-2 sensor-product-form" width="330px" outlined>
            <div class="ma-1 mb-1" style="font-weight: bold;">● 제품(모델) 정보</div>
            <v-text-field dense outlined hide-details class="ma-1" label="센서 제품(모델)명" v-model="sensorProduct_name" :readonly="!!sensorProduct_id" />

            <div class="ma-1 mt-2" style="font-size: 13px; color: #767676;">측정 데이터 종류 *</div>
            <v-radio-group dense hide-details class="ma-1 mt-0 measure-grid" v-model="sensorProduct_measureType">
              <v-radio
                v-for="item in orderedMeasureTypeItems"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </v-radio-group>

            <v-text-field dense outlined hide-details class="ma-1" label="제조사" v-model="sensorProduct_maker" />
            <v-text-field dense outlined hide-details class="ma-1" label="제품버전" v-model="sensorProduct_version" />
            <v-autocomplete dense outlined hide-details class="ma-1" label="Data 변환수식" v-model="sensorProduct_formula" :items="formulaItems" item-text="name" item-value="code" :menu-props="{ top: false, offsetY: true }" />
            <v-autocomplete dense outlined hide-details class="ma-1" label="사용" v-model="sensorProduct_useYn" :items="useYnItems" :menu-props="{ top: false, offsetY: true }" />
            <v-textarea dense outlined hide-details no-resize rows="2" class="ma-1" label="제원" v-model="sensorProduct_spec" />
            <v-text-field dense outlined hide-details class="ma-1" label="비고" v-model="sensorProduct_memo" />

            <v-card-actions class="justify-center">
              <v-btn rounded class="action_btn normal_btn_color" @click="saveSensorProduct()">저장</v-btn>
            </v-card-actions>
          </v-card>

          <v-card class="ma-1 pa-2" outlined style="flex: 1; min-width: 700px;">
            <div class="d-flex align-center ma-1">
              <div style="font-weight: bold;">● 제품(모델) 리스트</div>
              <v-spacer></v-spacer>
              <v-btn small rounded class="new_btn_color" @click="newSensorProductRegister()">신규 등록</v-btn>
            </div>
            <v-data-table
              dense
              height="600"
              fixed-header
              hide-default-footer
              :loading="loadingSensorProduct"
              :headers="sensorProductHeaders"
              :items="sensorProductItems"
              :items-per-page="500"
              no-data-text="등록된 제품(모델)이 없습니다."
              @click:row="selectSensorProduct"
              item-key="id"
            />
          </v-card>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Apis from "@/api/apis";
import Common from "@/utils/custom/common.js";

export default {
  name: "SensorProductDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    sensorProductItems: [],
    loadingSensorProduct: false,
    sensorProductHeaders: [
      { text: '제품(모델)명', align: 'left', value: 'product_name', width: '140px' },
      { text: '측정 데이터', align: 'left', value: 'measure_type_label', width: '110px' },
      { text: '사용여부', align: 'center', value: 'use_yn', width: '80px' },
      { text: '제조사', align: 'left', value: 'maker', width: '90px' },
      { text: 'Data 변환수식', align: 'left', value: 'formula', width: '160px' },
    ],
    measureTypeItems: Common.comboBaseCode("ES"),
    formulaItems: Common.comboBaseCode("CVEX"),
    useYnItems: ['사용', '중지'],

    sensorProduct_id: '',
    sensorProduct_name: '',
    sensorProduct_measureType: '',
    sensorProduct_maker: '',
    sensorProduct_version: '',
    sensorProduct_formula: '',
    sensorProduct_useYn: '사용',
    sensorProduct_memo: '',
    sensorProduct_spec: '',
  }),
  computed: {
    orderedMeasureTypeItems() {
      const order = ['ES01', 'ES02', 'ES03', 'ES04', 'ES05', 'ES06', 'ES07', 'ES08', 'ES09', 'ES10', 'ES11', 'ES12', 'ES13'];
      return order
        .map((code) => this.measureTypeItems.find((item) => item.code === code))
        .filter(Boolean);
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.listSensorProducts();
      }
    },
  },
  methods: {
    listSensorProducts() {
      this.loadingSensorProduct = true;
      Apis.listSensorModels({
        sel: "",
      }, (res) => {
        if (res.result) {
          this.sensorProductItems = res.data.map((item) => ({
            id: item.model,
            product_name: item.model,
            measure_type: item.type ? item.type.code : "",
            measure_type_label: item.type ? item.type.description : "",
            maker: item.maker,
            version: item.version,
            formula: item.formula ? item.formula.description : "",
            formula_code: item.formula ? item.formula.code : "",
            use_yn: item.disabled ? "중지" : "사용",
            memo: item.memo,
            spec: item.spec,
          }));
        } else {
          this.sensorProductItems = [];
          alert(res.message);
        }
        this.loadingSensorProduct = false;
      }).catch((err) => {
        console.log("listSensorModels API 호출 오류", err);
        this.loadingSensorProduct = false;
      });
    },
    newSensorProductRegister() {
      this.sensorProduct_id = '';
      this.sensorProduct_name = '';
      this.sensorProduct_measureType = '';
      this.sensorProduct_maker = '';
      this.sensorProduct_version = '';
      this.sensorProduct_formula = '';
      this.sensorProduct_useYn = '사용';
      this.sensorProduct_memo = '';
      this.sensorProduct_spec = '';
    },
    selectSensorProduct(item) {
      this.sensorProduct_id = item.id;
      this.sensorProduct_name = item.product_name;
      this.sensorProduct_measureType = item.measure_type;
      this.sensorProduct_maker = item.maker;
      this.sensorProduct_version = item.version;
      this.sensorProduct_formula = item.formula_code;
      this.sensorProduct_useYn = item.use_yn;
      this.sensorProduct_memo = item.memo;
      this.sensorProduct_spec = item.spec;
    },
    saveSensorProduct() {
      if (!this.sensorProduct_name.trim()) {
        alert('센서 제품(모델)명을 입력하세요');
        return;
      }
      if (!this.sensorProduct_measureType) {
        alert('측정 데이터 종류를 선택하세요');
        return;
      }
      Apis.saveSensorModel({
        is_update: !!this.sensorProduct_id,
        model: this.sensorProduct_name,
        type: this.sensorProduct_measureType,
        maker: this.sensorProduct_maker,
        version: this.sensorProduct_version,
        formula: this.sensorProduct_formula,
        disabled: this.sensorProduct_useYn === '중지',
        spec: this.sensorProduct_spec,
        memo: this.sensorProduct_memo,
        etc1: null,
        etc2: null,
        no1: null,
        no2: null,
      }, (res) => {
        if (res.result) {
          alert(res.message);
          this.newSensorProductRegister();
          this.listSensorProducts();
        } else {
          alert(res.message);
        }
      }).catch((err) => {
        console.log("saveSensorModel API 호출 오류", err);
        alert(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog_content{
  padding:10px;
  border-radius: 30px;
}
::v-deep .v-dialog.v-dialog--active.v-dialog--scrollable{
  border-radius: 30px;
  overflow: hidden;
}
.sensor-product-form ::v-deep .v-text-field,
.sensor-product-form ::v-deep .v-select{
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.sensor-product-form ::v-deep .measure-grid .v-input--radio-group__input{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 4px;
  row-gap: 2px;
}
.sensor-product-form ::v-deep .measure-grid .v-radio{
  margin: 0 !important;
  height: 28px;
}
.sensor-product-form ::v-deep .measure-grid label{
  font-size: 13px;
}
.action_btn{
  width:70px;
  height:35px !important;
  font-weight:bold;
  font-size:15px;
  letter-spacing: -0.5px;
  border-color:transparent;
}
.normal_btn_color{
  background-color: #3a4f3f !important;
  color:white;
}
.new_btn_color{
  background-color: rgb(245, 245, 245) !important;
  color:rgb(68, 68, 68);
}
</style>
